/**
 *Created by jmmartinez on 01/4/19
 *
 **/

import React from 'react'
import {connect} from "react-redux";
import './resources/css/layout.css';
import {Menu, MenuDivider} from "@blueprintjs/core";
import {
    estadoChangePagina,
    PAGE_USUARIOS,
    PAGE_ROLES,
    PAGE_PACIENTES,
    PAGE_DOCTORES,
    PAGE_CLINICAS,
    PAGE_CITAS,
    PAGE_PAGOS, PAGE_TRATAMIENTOS, PAGE_TRATAMIENTOTIPOS, PAGE_SALAESPERA,
} from './redux/estado/actions'
import MenuLateralItem from "../framework2/blueprint/MenuLateralItem"
import {version} from "../dental/Configuracion";



class MenuLateral extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }


    render() {
        const {auth} = this.props;
        console.log(auth);
        let versionActual= "Versión " + version;
        return (
            <>
                {
                    //auth.usuario &&
                    <Menu>
                        <MenuLateralItem id="citas" icon="timeline-events" paginaId={PAGE_CITAS} text="Citas"
                                         funcionDispatchOnClick={estadoChangePagina}/>
                        <MenuLateralItem id="citas" icon="shop" paginaId={PAGE_SALAESPERA} text="Sala de espera"
                                         funcionDispatchOnClick={estadoChangePagina}/>
                        <MenuLateralItem id="pacientes" icon="people" paginaId={PAGE_PACIENTES} text="Pacientes"
                                         funcionDispatchOnClick={estadoChangePagina}/>
                        <Menu.Divider/>

                        <MenuLateralItem id="general" icon="euro" paginaId={PAGE_PAGOS} text="Pagos"
                                         funcionDispatchOnClick={estadoChangePagina}/>
                        <Menu.Divider/>
                        <div style={{marginTop: 20, textAlign: 'center', fontSize: 12}}>{versionActual}</div>

                    </Menu>
                }
            </>
        );
    }
}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
    }
}

export default connect(mapStateToProps)(MenuLateral);
